import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag, Badge, Card, CardHeader, CardBody, CardFooter } from '@caos/ca-component-library';
import { McpServer } from '../types';
import { timeAgo } from '../lib/marketplace';
import './McpServerCard.css';

interface McpServerCardProps {
  server: McpServer;
}

export default function McpServerCard({ server }: McpServerCardProps) {
  const navigate = useNavigate();
  return (
    <div className="mcp-card-wrapper" onClick={() => navigate(`/mcp/${server.id}`)}>
      <Card size="full">
        <CardHeader className="mcp-card-header">
          <div className="mcp-card-badge-row">
            <Badge
              size="sm"
              shape="capsule"
              style={{ '--badge-bg': 'var(--ca-primary)' } as React.CSSProperties}
            >
              MCP Server
            </Badge>
          </div>
          <div className="mcp-card-name-row">
            <h3 className="mcp-card-name">{server.name}</h3>
            {server.environment && (
              <span className="mcp-card-environment">{server.environment.toLowerCase()}</span>
            )}
          </div>
        </CardHeader>

        <CardBody className="mcp-card-body">
          {server.description && (
            <p className="mcp-card-description">{server.description}</p>
          )}
          {server.tags?.length > 0 && (
            <div className="mcp-card-tools">
              <span className="mcp-card-tools-label">Tags</span>
              <div className="mcp-card-tools-list">
                {server.tags.map((tag) => (
                  <Tag key={tag} size="sm">
                    {tag}
                  </Tag>
                ))}
              </div>
            </div>
          )}
        </CardBody>

        <CardFooter className="mcp-card-footer">
          <div className="mcp-card-meta">
            <span className="mcp-card-owner">{server.owner}</span>
            <span className="mcp-card-separator">&#183;</span>
            <span className="mcp-card-updated">{timeAgo(server.last_updated)}</span>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
}
